import React from 'react';

export default function Header({ isLead }) {
  return (
    <div>
      <h2 className="sub-title gray-800 mb-0">{isLead ? 'Lead Automations' : 'Case Automations'}</h2>
      <p className="description text-muted">Automations that have been triggered in this case, listed chronologically</p>
    </div>
  );
}
